module.exports = __webpack_public_path__ + "static/media/palmeira.d5980e43.jpg";